import React from 'react';
import { Button, Select } from '../components';

const defaultConfig = {
    currentPageNumber: 1,
    pageSize: 20,
    totalItemCount: 0,
    totalPageCount: 0
}

class DataGridPager extends React.Component {
    static get pageActions() {
        return {
            NEXT: 'NEXT',
            PREVIOUS: 'PREVIOUS',
            JUMP: 'JUMP'
        }
    }

    pageChangeHandler(newPage, oldPage, pageAction, event) {
        if (typeof this.config.onPageChange === 'function') {
            return this.config.onPageChange(newPage, oldPage, pageAction, event);
        }
    }

    renderPrevBtn(config) {
        if (config.currentPageNumber <= 1) {
            return null;
        } else {
            return (
                <Button className="previous-button" onClick={e => this.pageChangeHandler(config.currentPageNumber - 1, config.currentPageNumber, DataGridPager.pageActions.PREVIOUS, e)}>Previous</Button>
            )
        }
    }

    renderNextBtn(config) {
        if (config.currentPageNumber >= config.totalPageCount) {
            return null;
        } else {
            return (
                <Button className="next-button" onClick={e => this.pageChangeHandler(config.currentPageNumber + 1, config.currentPageNumber, DataGridPager.pageActions.NEXT, e)}>Next</Button>
            )
        }
    }

    renderPageSelect(config) {
        return (
            <div className="page-select">
                <Select value={config.currentPageNumber} onChange={e => this.pageChangeHandler(e.target.value, config.currentPageNumber, DataGridPager.pageActions.JUMP, e)} rangeMin={1} rangeMax={config.totalPageCount} /> / { config.totalPageCount }
            </div>
        )
    }

    get config() {
        return Object.assign({}, defaultConfig, this.props.config);
    }

    set config(config) {
        console.error('config is read only');
        return config;
    }

    render () {
        let config = this.config;

        return (
            <div {...this.props} className={['component-data-grid-pager', this.props.className].join(' ')}>
                <div className="left-container">
                    { this.renderPrevBtn(config) }
                </div>
                <div className="center-container">
                    { this.renderPageSelect(config) }
                </div>
                <div className="right-container">
                    { this.renderNextBtn(config) }
                </div>
            </div>
        )
    }
}

export default DataGridPager;



// WEBPACK FOOTER //
// ./web-app/components/data-grid-pager.jsx